import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-requirement-detail',
  templateUrl: './requirement-detail.component.html',
  styleUrls: ['./requirement-detail.component.scss']
})
export class RequierementDetailComponent implements OnInit {
  @Input() formGroupName: string;
  @Input() contact: [];
  requirementForm: FormGroup;
  invalidForm = true;

  @Output()
  validatingForm = new EventEmitter<boolean>();

  constructor(
    private rootFormGroup: FormGroupDirective
  ) {
  }

  ngOnInit(): void {
    this.requirementForm = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
  }

  //#region [For Requirement]
  existsValue(): void {
    let trueCounter = 0;
    const checksValues = this.requirementForm.get('contact').value;

    checksValues.forEach((x) => {
      if (x) {
        trueCounter = trueCounter + 1;
      }
    });
    this.invalidForm = trueCounter <= 0;
    this.validatingForm.emit(this.invalidForm);
  }
  //#endregion
}
